import { render } from "./ClusterItem.vue?vue&type=template&id=afc8d01e&ts=true"
import script from "./ClusterItem.vue?vue&type=script&lang=ts"
export * from "./ClusterItem.vue?vue&type=script&lang=ts"

import "./ClusterItem.vue?vue&type=style&index=0&id=afc8d01e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__